<template>
  <div class="modal-container" v-if="show">
    <div class="modal-mask" @click="clickOutside"></div>
    <div
      class="modal-wrapper"
      :style="{ width: width + 'px', height: height + 'px' }"
    >
      <slot></slot>
      <slot name=""></slot>
      <a class="big" @click="close">
        <Icon type="close" />
      </a>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  model: {
    prop: "show",
    event: "close",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 650,
    },
    height: {
      type: Number,
      default: 400,
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      const modalWrapper = document.querySelector(".modal-wrapper");
      const modalMask = document.querySelector(".modal-mask");
      modalMask.classList.add("hide");
      modalWrapper.classList.add("hide");
      modalWrapper.addEventListener("animationend", () => {
        this.$emit("close", false);
      });
    },
    clickOutside() {
      console.log("clickoutside");
      //   const modalContainer = document.querySelector(".modal-container");
      //   if (e.target === modalContainer) {
      //     return;
      //   }
      //   console.log("bushi");
      this.close();
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
@import "~@/styles/mixin.less";
@import "~@/styles/common.less";
.modal-container {
  width: 100vw;
  height: 100vh;
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 999;
  transition: 0.5s;
  opacity: 1;
  &.hide {
    opacity: 0;
  }
}
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 50px);
  background-color: #fff;
  border-radius: 10px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  z-index: 1000;
  animation: show 0.5s;
  padding: 0 40px;
  &.hide {
    animation: hide 0.5s;
  }
  a {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    color: @gray;
    .flex-center();
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: inherit;
    cursor: pointer;
    transition: 0.5s;
    &:hover {
      color: @primary;
      transform: scale(1.2);
    }
  }
}

@keyframes show {
  0% {
    transform: translate(-50%, 100px);
    opacity: 0;
  }
  100% {
    transform: translate(-50%, 50px);
    opacity: 1;
  }
}
@keyframes hide {
  0% {
    transform: translate(-50%, 50px);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, 100px);
    opacity: 0;
  }
}
</style>
